module.exports = __webpack_public_path__ + "img/earth.e349f7f8.svg";